









import { Component, Vue } from 'vue-property-decorator'
import GetNewsBoardFileApi from '@/app/model/api/getNewsBoardFileApi'
import NewsBoardContentDetailApi from '@/app/model/api/newsBoardContentDetailApi'
import CommonClass from '@/app/module/common'
import { routerPath, errorFlag, common } from '@/app/model/store/domain/const'
import { MetaInfo } from 'vue-meta'
import PdfPreview from '@/app/components/Common/PdfPreview.vue'

@Component({
  components: {
    PdfPreview
  },
  metaInfo (this: NewsBoardPdfPreview): MetaInfo {
    return {
      title: this.setPageTitle
    }
  }
})

export default class NewsBoardPdfPreview extends Vue {
  private newsBoardName: string = ''
  private newsBoardContentName: string = ''
  private blobPath: any = {}
  private pageTitle = ''

  public get setPageTitle () {
    return this.pageTitle
  }

  created () {
    this.getNewsBoardDetail()
  }

  destroy () {
    URL.revokeObjectURL(this.blobPath as string)
  }

  private getNewsBoardDetail () {
    (async () => {
      const result = await NewsBoardContentDetailApi.getDetail(this.$route.params.news_board_content_id)
      if (result.isOk()) {
        const payload = result.getPayload()
        this.newsBoardName = payload.news_board.news_board_name
        this.newsBoardContentName = payload.news_board_content.content_name
        this.pageTitle = this.newsBoardName + '_' + this.newsBoardContentName + ' | ' + common.SYSTEM_NAME

        // 取得したかわらばんIDと、URLのかわらばんIDが一致している かつ ファイルがあるか確認
        if (payload.news_board.news_board_id === Number(this.$route.params.news_board_id) && payload.news_board_content.content_file !== '') {
          // PDF情報を取得するIDを設定
          this.getNewsBoardFile(Number(this.$route.params.news_board_content_id))
        } else {
          // 存在しない場合は404遷移
          this.$store.commit('routeState/setErrorFlag', errorFlag.ERROR_FLAG_DEFAULT)
          this.$router.push(routerPath.PATH_ERROR_PAGE).catch(e => {})
        }
      } else {
        // 200以外の場合はerrorページ遷移
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  private async getNewsBoardFile (id: number) {
    const result = await GetNewsBoardFileApi.getNewsBoardFile(id)

    if (typeof result === 'string') {
      this.blobPath = result
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
    }
  }
}
